import { useEffect, useState } from 'react';
import { IJourneyResp, ISchedules } from '../../../../../services/journey.service';

export function usePatientCare(journey: IJourneyResp) {
  const [attendance, setAttendance] = useState({
    hasConfirmed: false,
    confirmedSchedules: [] as ISchedules[]
  });
  function findConfirmedAttendees(): ISchedules[] | undefined {
    const { schedules } = journey;
    return schedules?.filter(schedule => schedule.attendanceConfirmed && schedule.dateEnd < new Date().toISOString());
  }

  useEffect(() => {
    const confirmed = findConfirmedAttendees();
    setAttendance({
      hasConfirmed: !!confirmed?.length,
      confirmedSchedules: confirmed || []
    });
  }, [journey]);

  return {
    attendance
  };
}
